export default __webpack_public_path__ + "static/media/hot-15.a47c767b.png";